import React from 'react'
import FieldProto from "../../../../../../fields3/proto/field-proto"
import FieldOptionDefault from "./item-default"
import FieldItemWithOptions from "./with-options/item-with-options"

type Props = {
    field                   : FieldProto
    params?                 : any

    selected                : boolean
    hasIcons                : boolean
    showModifierOptions?    : boolean
    disabled?               : boolean

    onClick                 : {(fieldId: ID, params?: any): void}
}

export default function FieldItem(props:Props) {

    if (props.showModifierOptions && props.field.modifierOptions) {
        return <FieldItemWithOptions field      = {props.field}
                                     params     = {props.params}
                                     selected   = {props.selected}
                                     hasIcons   = {props.hasIcons}
                                     disabled   = {props.disabled}
                                     onClick    = {props.onClick}/>
    } else {
        return <FieldOptionDefault field    = {props.field}
                                   selected = {props.selected}
                                   hasIcons = {props.hasIcons}
                                   disabled = {props.disabled}
                                   onClick  = {props.onClick}/>
    }
}